import styled from "styled-components";

export const RPCList = styled.div`
.disclosure {
  grid-column: 1 / -1;
  position: relative;
  padding: 30px;

  @media screen and (max-width:968px) {
    width: 100vw;
    overflow-x: scroll;
  }
}

.table {
  border-collapse: collapse;
  margin: 0 auto;
}

.table {
  white-space: nowrap;
}

.table caption,
.table th,
.table td {
  padding: 4px 12px;
  border: 1px solid hsl(0deg 0% 95%);
}

.table caption {
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 0;
}

.table th {
  font-weight: 500;
}

.shimmer {
  border-radius: 4px;
  height: 20px;
  width: 100%;
  min-width: 40px;
  background-image: var(--linear-gradient);
  background-size: 600px;
  animation: loading 2s infinite;
}

.trustScore {
  text-align: center;
  color: var(--trust-color);
}

.helperText {
  text-align: center;
}

.helperText a {
  text-decoration: underline;
}

@keyframes loading {
  0% {
    background-position: -100px;
  }
  40%,
  100% {
    background-position: 140px;
  }
}
`